<template>

  <el-form label-width="auto" label-position="left">
    <el-form-item label="数据中间件">
      <el-select v-model="attrs.tableName" default-first-option filterable @change="handleTableChange">
        <el-option v-for="(item,index) in tableNames" :key="index" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-tooltip v-if="attrs.form" placement="top" content="表单名称应用到节点名">
        <el-button icon="SetUp" style="margin-left: 10px" plain @click="handleChangeNodeName"></el-button>
      </el-tooltip>
    </el-form-item>
  </el-form>

  <el-table ref="table" :data="columns" row-key="name" border
            style="width: 100%;background: white;--el-table-tr-bg-color:white;--el-table-header-bg-color:white"
            :header-cell-style="{color:'black'}"
            size="small" :tree-props="{checkStrictly:false}"
            @selection-change="handleSelectionChange" max-height="calc(100vh - 360px)">
    <el-table-column type="selection" width="35px" prop="select" :reserve-selection="true" :selectable="(row)=>{
     return row.tag!=='id';
    }"></el-table-column>
    <el-table-column label="名称" prop="name">
      <template #default="scope">
        <span>{{ scope.row.name }}</span>
      </template>
    </el-table-column>
    <el-table-column label="别名" width="120px">
      <template #default="scope">
        <el-input v-model="scope.row.alias" size="small" :key="scope.row.name" @input="(val)=>{
          let match = attrs.keepColumns.find(find => find.name === scope.row.name);
          if(match)
          match.alias = val;
        }"></el-input>
      </template>
    </el-table-column>
  </el-table>

</template>

<script>
import {mapStores} from "pinia";
import {useEtlStore} from "@/stores/etl";
import {useFormStore} from "@/stores/form";

export default {
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapStores(useEtlStore, useFormStore)
  },
  data() {
    return {
      ele: {},
      attrs: {
        app: '',
        form: ''
      },
      columns: [],
      multipleSelection: [],
      tableNames: []
    }
  },
  async created() {
    this.ele = this.element;
    this.attrs = this.element.attrs;

    this.initTableNames();

  },
  methods: {
    initTableNames() {
      this.etlStore.middlewares().then(async res => {
        if (res.code === 200) {
          this.tableNames = res.data
          if (this.attrs.tableName) {
            await this.initColumns()
            this.$nextTick(()=>{
              this.select()
            })
          }
        } else {
          this.message(res.message, 'error');
        }
      })
    },
    handleTableChange() {
      this.attrs.keepColumns = [];
      this.initColumns();
    },
    async initColumns() {
      await this.etlStore.inputColumns(this.element).then(res => {
        this.columns = res.data;
        this.columns.forEach(row => {
          row.alias = this.attrs.keepColumns.find(find => find.name === row.name)?.alias;
        })
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.save()
    },
    save() {
      this.$nextTick(() => {
        this.attrs.keepColumns = this.multipleSelection.map(mapper => {
          return {
            id: mapper.id,
            parent: mapper.parent,
            name: mapper.name,
            alias: mapper.alias,
          }
        });
      })
    },
    select() {
      let rows = this.attrs.keepColumns;
      let names = rows.map(mapper => mapper.name);
      this.columns.forEach((row) => {
        let selected = names.includes(row.name);
        this.$refs.table.toggleRowSelection(row, selected)
      });
    }

  }
}

</script>


<style scoped lang="scss">

.el-select {
  width: 220px;
}

</style>